import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Solución radical: Desactivar completamente ResizeObserver
if (typeof window !== 'undefined') {
  // Reemplazar ResizeObserver con una implementación vacía
  window.ResizeObserver = class ResizeObserver {
    constructor(callback) {
      // No hacer nada
    }
    observe() {
      // No hacer nada
    }
    unobserve() {
      // No hacer nada
    }
    disconnect() {
      // No hacer nada
    }
  };
}

// Interceptar console.error y console.warn como respaldo
const originalError = console.error;
console.error = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && message.includes('ResizeObserver')) {
    return; // Silenciar errores de ResizeObserver
  }
  originalError.apply(console, args);
};

const originalWarn = console.warn;
console.warn = (...args) => {
  const message = args[0];
  if (typeof message === 'string' && message.includes('ResizeObserver')) {
    return; // Silenciar warnings de ResizeObserver
  }
  originalWarn.apply(console, args);
};

// Interceptar errores no capturados
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  if (reason && typeof reason === 'string' && reason.includes('ResizeObserver')) {
    event.preventDefault();
  }
});

// Interceptar errores globales
window.addEventListener('error', (event) => {
  const error = event.error;
  if (error && typeof error === 'string' && error.includes('ResizeObserver')) {
    event.preventDefault();
  }
  if (error && error.message && error.message.includes('ResizeObserver')) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
